import React from "react";
import ReactDOM from "react-dom";
import Start from "./Start";

const App = ({ route }) => {
	return (
		<div>
			<Start />
		</div>
	);
};

class WebComponent extends HTMLElement {
	connectedCallback() {
		// Criamos um container interno para renderizar o React
		this.renderRoot = document.createElement("div");
		this.appendChild(this.renderRoot);

		// Renderiza usando ReactDOM.render (React 16)
		ReactDOM.render(
			<App route={this.getAttribute("route")} />,
			this.renderRoot
		);
	}

	disconnectedCallback() {
		// Remove o componente para evitar memory leaks
		ReactDOM.unmountComponentAtNode(this.renderRoot);
		this.removeChild(this.renderRoot);
		delete this.renderRoot;
	}
}

const ELEMENT_ID = "sinpol-user-form-element";

// Registra o Custom Element
if (!customElements.get(ELEMENT_ID)) {
	customElements.define(ELEMENT_ID, WebComponent);
}
